import createMutator from '../../utils/createMutator';

export const setMessage = createMutator('set', 'message');
export const setStatus = createMutator('set', 'status');